import React, { useEffect, useRef, useState } from 'react';
import { Fade } from '@mui/material';
import './puente.scss';

export interface IPuenteProps {
    img: string;
    marginTop: string;
    marginBottom: string;
}

const Puente = ({ img, marginTop, marginBottom }: IPuenteProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const PuenteRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (PuenteRef.current) {
            observer.observe(PuenteRef.current);
        }
        return () => observer.disconnect();
    }, []);
    return (
        <Fade in={isVisible} timeout={2000}>
            <img
                ref={PuenteRef}
                src={img}
                alt=""
                className="o-puente"
                style={{
                    marginTop: marginTop,
                    marginBottom: marginBottom + 'px',
                }}
            />
        </Fade>
    );
};

export default Puente;
